import {
  SELECT_BUTTON_CLASS_NAME,
  SUMMARY_FILTER_SELECT_CLASS_NAME,
  FORM_SELECT_BUTTON_CLASS_NAME,
  COMPACT_SELECT_CLASS_NAME,
} from '../../constants/select';

export const subtlePrimaryBorderMenuProps = {
  PaperProps: {
    sx: (theme) => ({
      border: `1px solid ${theme.palette.primary.A300}`,
      borderRadius: '8px',
    }),
  },
};

export const selectButton = ({ theme, mainColor }) => ({
  maxWidth: '100%',
  borderRadius: 8,
  border: '1px solid',
  borderColor: mainColor,
  color: theme.palette.gray.A700,
  fontWeight: 500,
  fontSize: theme.typography.small_3.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.small_2.fontSize,
  },
  width: 250,
  backgroundColor: '#fff',
  '& .MuiSelect-icon': {
    color: mainColor,
    fontSize: '28px',
    width: 28,
    height: 28,
  },
  '&.Mui-focused': {
    color: mainColor,
  },
  '&.Mui-focused .MuiSelect-icon': {
    color: mainColor,
  },
  '&:before': {
    borderBottom: 'none !important',
  },
  '&:after': {
    borderBottom: 'none !important',
  },
  '& .MuiSelect-select, & .MuiInputBase-input': {
    fontSize: 'inherit',
    fontWeight: 500,
    padding: '12px',
  },
});

export const formSelectButton = ({ theme, mainColor }) => ({
  maxWidth: '100%',
  height: '100%',
  borderRadius: 8,
  border: '1px solid',
  borderColor: theme.palette.gray.A400,
  color: theme.palette.gray.A400,
  fontWeight: 500,
  fontSize: theme.typography.small_2.fontSize, // 14px
  lineHeight: '140%',
  backgroundColor: '#fff',
  '& .MuiSelect-icon': {
    color: theme.palette.gray.A500,
    fontSize: theme.typography.large_2.fontSize,
    width: 28,
    height: 28,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.medium_2.fontSize,
      width: 20,
      height: 20,
    },
  },
  '&.Mui-focused': {
    color: mainColor,
    borderColor: mainColor,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: mainColor,
    },
  },
  '&.Mui-focused .MuiSelect-icon': {
    color: theme.palette.gray.A500,
  },
  '&:before': {
    borderBottom: 'none !important',
  },
  '&:after': {
    borderBottom: 'none !important',
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
    fontSize: theme.typography.small_2.fontSize, // 14px
    '& fieldset': {
      borderColor: theme.palette.gray.A400,
    },
  },
  '& .MuiSelect-select, & .MuiInputBase-input': {
    color: theme.palette.gray.A400,
    fontSize: theme.typography.small_2.fontSize, // 14px
    fontWeight: 500,
    lineHeight: '140%',
    padding: '12px 40px 12px 12px',
    '&::placeholder': {
      color: theme.palette.gray.A400,
    },
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent',
    borderRadius: 8,
  },
  '&:not(:has(.MuiSelect-nativeInput[value=""])) .MuiSelect-select': {
    color: theme.palette.gray.A700,
  },
});

export const summaryFilterSelect = ({ theme, mainColor }) => ({
  height: '100%',
  backgroundColor: theme.palette.common.white,
  color: mainColor,
  border: 'none',
  borderStyle: 'solid',
  textAlign: 'center',
  borderRadius: 8,
  borderColor: 'transparent !important',
  outline: 'none !important',
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
    borderRadius: '8px !important',
  },
  '& .MuiOutlinedInput-root': {
    height: '100%',
    fontSize: theme.typography.small_3.fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.small_2.fontSize,
    },
    '& fieldset': {
      border: 'none !important',
    },
  },
  '& .MuiSelect-select, & .MuiInputBase-input': {
    fontSize: theme.typography.small_3.fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.small_2.fontSize,
    },
  },
  '& .MuiSelect-icon': {
    color: mainColor,
    fontSize: theme.typography.large_2.fontSize,
    width: 28,
    height: 28,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.medium_2.fontSize,
      width: 20,
      height: 20,
    },

  },
});

export const compactSelect = {
  height: 44,
  '& .MuiSelect-select': {
    minHeight: 'unset',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
};

const MuiSelect = {
  defaultProps: {
    inputProps: {
      'data-hj-allow': '',
      sx: {
        borderRadius: 2,
        minHeight: 48,
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiOutlinedInput-root': {
        '& fieldset': {
          borderRadius: 2,
        },
      },
      [`&.${SELECT_BUTTON_CLASS_NAME}`]: selectButton({ theme, mainColor: theme.palette.primary.main }),
      [`&.${FORM_SELECT_BUTTON_CLASS_NAME}`]: formSelectButton({ theme, mainColor: theme.palette.primary.main }),
      [`&.${SUMMARY_FILTER_SELECT_CLASS_NAME}`]: summaryFilterSelect({ theme, mainColor: theme.palette.primary.main }),
      [`&.${COMPACT_SELECT_CLASS_NAME}`]: compactSelect,
    }),
    select: {
      fontSize: '12px',
      padding: '12px',
    },
    icon: {
      fontSize: '20px',
    },
  },
};

export default MuiSelect;
